import React from 'react';
import { ObjectTypes } from '../../../../api/consts';
import BaseSettingsPasswordSecurity from '../../AbstractObjects/BaseSettingsPasswordSecurity';

function PortalSettingsUserPasswordSecurity({
    portalSettingsObject,
    setPortalSettingsData
}) {
    return (
        <BaseSettingsPasswordSecurity
            settingsObject={portalSettingsObject}
            setSettingsData={setPortalSettingsData}
            objectType={ObjectTypes.PORTAL_SETTINGS}
            />
    )
}

export default PortalSettingsUserPasswordSecurity;